import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { ShopProductCard } from "./ShopProductCard";

const WIDTH = ["max-w-md", "max-w-md", "max-w-3xl", "max-w-5xl"];
const COLS = ["", "", "sm:grid-cols-2", "sm:grid-cols-2 lg:grid-cols-3"];

export const CollectionDialog = ({ collection, products, tint, onClose, onOpenProduct }) => (
  <Dialog open={!!collection} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className={`${WIDTH[Math.min(products.length, 3)]} bg-[#F9F6F0] border-[#E7DFD5] max-h-[92vh] overflow-y-auto`} data-testid="shop-collection-dialog">
      {collection && (
        <>
          <p className="text-xs uppercase tracking-[0.25em]" style={{ color: tint }}>{collection.kind}</p>
          <DialogTitle className="font-display text-3xl text-[#4B3A2F] leading-tight">{collection.title}</DialogTitle>
          {collection.subtitle && <p className="font-display text-lg text-[#4B3A2F]/75 -mt-4">{collection.subtitle}</p>}
          <DialogDescription className="font-body text-[#2C2724]/80">{collection.note}</DialogDescription>
          <div className={`grid grid-cols-1 ${COLS[Math.min(products.length, 3)]} gap-6 mt-4`}>
            {products.map((p) => (
              <ShopProductCard key={p.id} product={p} tint={tint} onOpen={onOpenProduct} />
            ))}
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
